import { SummitConfirmConfig } from './summit-confirm-config';

export class SummitConfirmConfigsDefaults {
  static editHistoricalPayroll(element?: any): SummitConfirmConfig {
    return {
      title: 'Editing Historical Payroll Item',
      confirmType: 'delete',
      name: `Confirm that you are editing Historical Entries?`,
      question: 'You are about to edit a historical record that was used to produce Payroll and/or Reports.',
      action: 'Edit'
    } as SummitConfirmConfig;
  }
  static delete(element?: any): SummitConfirmConfig {
    return {
      confirmType: 'delete',
      name: `Deleting ${element?.name ?? 'item'}`,
      question: 'Are you sure you want to delete this item?',
      action: 'Delete'
    } as SummitConfirmConfig;
  }
  static deleteMulti(elements: number): SummitConfirmConfig {
    return {
      confirmType: 'delete',
      name: `Deleting ${elements} items`,
      question: 'Are you sure you want to delete these items?',
      action: 'Delete'
    } as SummitConfirmConfig;
  }
}
